<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>

<div class="blue full body">
  <app-navbar></app-navbar>
  <!-- <app-sqanimation></app-sqanimation> -->
  <div class="main">
    <app-sqanimation></app-sqanimation>
    <div class="struct-heading">
      <h1>LOGIN</h1>

      
     </div>
  
     <!-- <div class="bganimation">
     </div> -->
  <div class="form">
    
     
      <form
        [formGroup]="firstFormGroup"
        style="border-radius: 1.5rem"
        class="main-form"
      >
        <br />
        <mat-form-field appearance="outline" class="input-field">
          <input
            matInput
            placeholder="Email ID*"
            formControlName="id"
            required
          />
          <mat-error *ngIf="firstFormGroup.controls['id'].hasError('required')">
            Email ID is required!
          </mat-error> </mat-form-field
        ><br />
        <mat-form-field appearance="outline" class="input-field">
          <input
            matInput
            formControlName="password"
            placeholder="Password*"
            [type]="hide ? 'password' : 'text'"
            name="password"
            required
          />
          <button
            style="color: black"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
          </button>
          <mat-error
            *ngIf="firstFormGroup.controls['password'].hasError('required')"
          >
            Password is required!
          </mat-error>
        </mat-form-field>
        <div class="butbut">
          <!-- <button class="green-button" mat-button matStepperPrevious>Back</button> -->
          <!-- <button class="green-button" mat-button (click)="stepper.reset()">Reset</button> -->
          <button class="green-button" mat-button (click)="submit()">
            Submit
          </button>
          <!-- <h5>Please check your registered Email ID for login credentials</h5> -->
        </div>
      </form>
      <div class="foot">
        <div>
          <h5>
            <a style="color: black; cursor: pointer; z-index: 100;" (click)="register()"
              >New User? Register Now</a
            >
          </h5>
        </div>
        <div class="end">
          <h5>
            <a style="color: black; z-index: 100" [routerLink]="['/reset']"
              >Forgot password, Click here</a
            >
          </h5>
        </div>
      </div>
    </div>
  </div>

  <div style="background: #04070a">
    <app-footer></app-footer>
  </div>
  
</div>

